import { useParams } from "react-router-dom"
import "../../App.scss"
import products from "../shop/products.json"
import { useState } from "react";


function ProductPage() {


    const { pid } = useParams();

    const [currentImg, setCurrentImg] = useState(() => {
        const product = products.find(product => product.id == pid);
        return product ? product.image : null;
    });

    const onMouseOverChange = (x) => {
        setCurrentImg(x)
    }




    return (
        <div className="MainDiv">
            {
                products.map((p) => (
                    p.id == pid
                        ? (
                            <div className="product-page-box">
                                <div className="product-left">
                                    {
                                        p.images
                                            ? (
                                                <div className="prodPageImgDiv">
                                                    {
                                                        p.images.map((pi) => (
                                                            <div className={pi == currentImg ? "prodPageSmallImgDiv activeImgProdPage" : "prodPageSmallImgDiv"}>
                                                                <img className="prodPageSmallImg" onMouseEnter={() => { onMouseOverChange(pi) }} onClick={() => { setCurrentImg(pi) }} src={pi} />
                                                            </div>
                                                        ))
                                                    }
                                                </div>
                                            )
                                            : null
                                    }
                                    <img className="prodPageImg" src={currentImg} />


                                </div>
                                <div className="product-right">
                                    <p className="prodPageName" >{p.name}</p>
                                    <div className="links-div">
                                        {
                                            p.available
                                                ? (
                                                    p.available.map((pa) => (

                                                        <a href={pa.link} target="blank">
                                                            <div className={
                                                                pa.name == "amazon" ? "link-button amazon" : (pa.name == "flipkart" ? "link-button flipkart" : (pa.name == "meesho" ? "link-button meesho" : (pa.name == "call" ? "link-button call" : "link-button")))
                                                            } >

                                                                <p className="linkText">Buy it on {pa.name}</p>
                                                            </div>
                                                        </a>

                                                    ))

                                                )
                                                : null
                                        }
                                    </div>
                                    {
                                        p.stats
                                            ? (
                                                <div className="prodPageStats">

                                                    <div className="stats-list">
                                                        {
                                                            p.stats.map((pp) => (
                                                                <div className="stat">
                                                                    <p className="statName">{pp.name}  : </p>
                                                                    <p className="statValue" >{pp.value}</p>
                                                                </div>
                                                            ))
                                                        }
                                                    </div>
                                                </div>
                                            )
                                            : null
                                    }
                                    {
                                        p.ingredients
                                            ? (
                                                <div className="prodPageAbout">
                                                    <p className="prodPageHeading">Ingredients</p>
                                                    <p className="prodPageIngText">
                                                        {p.ingredients}
                                                    </p>
                                                </div>
                                            )
                                            : null
                                    }
                                    {
                                        p.about
                                            ? (
                                                <div className="prodPageAbout">
                                                    <p className="prodPageHeading">About</p>
                                                    <ul className="prodPageAboutList">
                                                        {
                                                            p.about.map((pa) => (
                                                                <li className="prodPageIngText">
                                                                    {pa}
                                                                </li>
                                                            ))
                                                        }
                                                    </ul>
                                                </div>
                                            )
                                            : null
                                    }

                                    {/* <div className="useful-box">

                                    </div> */}
                                </div>
                            </div>
                        )
                        : null
                ))
            }
        </div>
    )
}

export default ProductPage